// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-layout-header {\n  -moz-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n  position: fixed;\n  width: calc(100vw - 200px);\n  z-index: 10;\n}\n.main-layout-content {\n  height: 100vh;\n  padding-top: 65px;\n}\n", ""]);
// Exports
module.exports = exports;
